import { Link, Text, HStack, VStack, Heading } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";

export default function TopLogo({ network }) {
    return (
        <VStack py={"10"}>
            <Heading size={"xl"}>
                100時間後に死ぬ
                <Text as={"span"} color={"green.400"}>
                    NFT
                </Text>
            </Heading>
            {network === "testnet" && (
                <Heading size={"sm"} color={"orange.400"}>
                    Testnet version (100x speed)
                </Heading>
            )}
            {network === "local" && (
                <Heading size={"sm"} color={"orange.400"}>
                    Local version (100x speed)
                </Heading>
            )}
            {network === "mainnet" && (
                <HStack fontSize="sm">
                    <Link as={NavLink} exact to="/">
                        Home
                    </Link>
                    <Text>|</Text>
                    <Link as={NavLink} exact to="/all">
                        みんなのNFT
                    </Link>
                </HStack>
            )}
            {network === "testnet" && (
                <HStack fontSize="sm">
                    <Link as={NavLink} exact to="/">
                        Home
                    </Link>
                    <Text>|</Text>
                    <Link as={NavLink} exact to="/test">
                        Home(test)
                    </Link>
                    <Text>|</Text>
                    <Link as={NavLink} exact to="/test-all">
                        みんなのNFT(test)
                    </Link>
                </HStack>
            )}
            <HStack pt="5">
                <Text fontSize="4xl">🐊</Text>
                <Text fontSize="3xl">🐊</Text>
                <Text fontSize="2xl">🐊</Text>
                <Text fontSize="xl">🐊</Text>
                <Text fontSize="4xl">🥚</Text>
            </HStack>
        </VStack>
    );
}
